
  export enum ApprovalStatus {
    
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    TO_APPROVE="TO APPROVE"
  }
  
  export enum DateOptions {
    ASSIGNED_DATE = 1,
    EXPECTED_DEPARTURE = 2,
    EXPECTED_ARRIVAL = 3,
  }
  
  export enum StatusOptions {
    ASSIGNED = "ASSIGNED",
    ALLOCATED = "ALLOCATED",
    IN_PROGRESS = "IN PROGRESS",
    WAITING_FOR_DOCUMENTATION = "WAITING FOR DOCUMENTATION",
    COMPLETED = "COMPLETED",
  }
  
  export enum StatusOptionsDocuments {
    PROFILO_PARZIALE ="Profilo Parziale",
    IN_VERIFICA="In Verifica",
    IN_GESTIONE="In Gestione",
    ERROR="Errore",
    ACCEPTED1="Approvato",
    ACCEPTED2="Verificata",
    GESTITO="Gestito",
    REJECTED="Annullato",
    VALID="VALID"
  }
  